import {Product, productDecoder} from './Product'
import {PriceDefinition, priceDefinitionDecoder} from './PriceDefinition'
import {array, Decoder, field, object} from 'json-bouncer'

export interface ProductWithPriceDefinitions {
    readonly product: Product
    readonly priceDefinitions: PriceDefinition[]
}

export function productWithPriceDefinitionsDecoder(): Decoder<ProductWithPriceDefinitions> {
    return object({
        product: field('product', productDecoder()),
        priceDefinitions: field('priceDefinitions', array(priceDefinitionDecoder())),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ProductWithPriceDefinitions.ts